import { useEffect, useState } from 'react';

// actions
import { changePageTitle } from '../redux/actions';

// hooks
import { useRedux } from '.';
import {setTitle} from "_ui/Meta";

export default function usePageTitle(value: {
    title: string;
    breadCrumbItems: {
        label: string;
        path: string;
        active?: boolean;
    }[];
}) {
    const { dispatch } = useRedux();
    setTitle(value.title);

    const [pageTitle] = useState(value);

    useEffect(() => {
        // set page title
        dispatch(changePageTitle(pageTitle));
    }, [dispatch, pageTitle]);
}
